export const cardTypeNormalize = (cardType: string): string => {
  cardType = cardType.toLowerCase();
  cardType = cardType === 'master' ? 'mastercard' : cardType;
  cardType = cardType === 'american_express' ? 'amex' : cardType;
  return cardType;
};
